/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeholder_Legal_Name_BusinessInputs */

const en_placeholder_legal_name_business = /** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Best Cars LLC`)
};

const es_placeholder_legal_name_business = /** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Best Cars LLC`)
};

const fr_placeholder_legal_name_business = /** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Meilleurs Moteurs SARL`)
};

const de_placeholder_legal_name_business = /** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Best Cars GmbH`)
};

const id_placeholder_legal_name_business = /** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. PT Sukses Makmur`)
};

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const ja_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const zh_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const ar_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const it_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const ru_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const pt_placeholder_legal_name_business = en_placeholder_legal_name_business;

/** @type {(inputs: Placeholder_Legal_Name_BusinessInputs) => LocalizedString} */
const ko_placeholder_legal_name_business = en_placeholder_legal_name_business;

/**
* | output |
* | --- |
* | "e.g. Best Cars LLC" |
*
* @param {Placeholder_Legal_Name_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const placeholder_legal_name_business = /** @type {((inputs?: Placeholder_Legal_Name_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholder_Legal_Name_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeholder_legal_name_business(inputs)
	if (locale === "es") return es_placeholder_legal_name_business(inputs)
	if (locale === "fr") return fr_placeholder_legal_name_business(inputs)
	if (locale === "de") return de_placeholder_legal_name_business(inputs)
	if (locale === "ja") return ja_placeholder_legal_name_business(inputs)
	if (locale === "zh") return zh_placeholder_legal_name_business(inputs)
	if (locale === "ar") return ar_placeholder_legal_name_business(inputs)
	if (locale === "id") return id_placeholder_legal_name_business(inputs)
	if (locale === "it") return it_placeholder_legal_name_business(inputs)
	if (locale === "ru") return ru_placeholder_legal_name_business(inputs)
	if (locale === "pt") return pt_placeholder_legal_name_business(inputs)
	return ko_placeholder_legal_name_business(inputs)
});